 import { Header } from "@/components/Header";
 import { Footer } from "@/components/Footer";
 import { SEO } from "@/components/SEO";
 import { Button } from "@/components/ui/button";
 import { Card, CardContent } from "@/components/ui/card";
 import { Users, BookOpen, MessageCircle, Target, ArrowRight, Clock, Trophy, Zap } from "lucide-react";
 import { Link } from "react-router-dom";
 
 const features = [
   { icon: Users, title: "그룹 스터디룸", description: "여러 명이 함께 참여할 수 있는 그룹 스터디룸을 만드세요." },
   { icon: BookOpen, title: "주제별 공부", description: "같은 과목이나 시험을 준비하는 사람들과 함께하세요." },
   { icon: Target, title: "공동 목표", description: "그룹 목표를 설정하고 함께 달성해 나가세요." },
   { icon: MessageCircle, title: "토론 기능", description: "공부하면서 질문하고 토론하며 이해도를 높이세요." },
   { icon: Clock, title: "스케줄 관리", description: "정기적인 그룹 스터디 일정을 관리하세요." },
   { icon: Trophy, title: "그룹 리더보드", description: "그룹 내 경쟁을 통해 동기부여를 높이세요." },
 ];
 
 export default function GroupStudyKr() {
   return (
     <div className="min-h-screen bg-background">
       <SEO 
         title="그룹 스터디 | CSW | Online Workspace | Productivity Tool | Study Stream"
         description="그룹 스터디룸에서 여러 명이 함께 공부하세요. 주제별 공부, 공동 목표, 토론 기능을 제공합니다."
         keywords="그룹 스터디, 온라인 스터디 그룹, 팀 스터디, 스터디 모임, 함께 공부하기"
         canonicalUrl="/kr/group-study/"
       />
       <Header />
       
       <main>
         <section className="relative min-h-[90vh] flex items-center justify-center overflow-hidden">
           <div className="absolute inset-0 bg-gradient-to-b from-background via-background to-muted" />
           <div className="absolute top-20 left-20 w-96 h-96 bg-primary/20 rounded-full blur-[120px] animate-glow-pulse" />
           
           <div className="container relative z-10 mx-auto px-4 sm:px-6 lg:px-8">
             <div className="max-w-4xl mx-auto text-center space-y-8">
               <h1 className="font-display text-5xl sm:text-6xl lg:text-7xl font-bold leading-tight">
                 <span className="text-gradient">그룹 스터디</span>
               </h1>
               <p className="text-xl sm:text-2xl text-muted-foreground font-light max-w-xl mx-auto">
                 함께하면 더 효과적. 그룹으로 목표를 달성하세요.
               </p>
               <Button size="lg" className="group bg-primary hover:bg-primary/90 text-primary-foreground font-semibold px-8 py-6 text-lg" asChild>
                 <a href="https://app.csw.live" target="_blank" rel="noopener noreferrer">
                   그룹 만들기 <ArrowRight className="ml-2 h-5 w-5 group-hover:translate-x-1 transition-transform" />
                 </a>
               </Button>
             </div>
           </div>
         </section>
 
         <section className="py-24 px-4 relative overflow-hidden">
           <div className="container mx-auto max-w-6xl">
             <div className="text-center mb-16">
               <h2 className="text-4xl md:text-5xl font-bold font-display mb-6">
                 <span className="text-gradient">그룹</span> 스터디의 장점
               </h2>
             </div>
             <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
               {features.map((feature) => {
                 const Icon = feature.icon;
                 return (
                   <Card key={feature.title} className="group bg-card/50 backdrop-blur-sm border-border/50 hover:border-primary/50 transition-all hover:scale-105">
                     <CardContent className="p-8 space-y-4">
                       <div className="w-12 h-12 rounded-xl bg-gradient-to-br from-primary/20 to-secondary/20 flex items-center justify-center">
                         <Icon className="w-6 h-6 text-primary" />
                       </div>
                       <h3 className="text-xl font-semibold text-foreground font-display">{feature.title}</h3>
                       <p className="text-muted-foreground leading-relaxed">{feature.description}</p>
                     </CardContent>
                   </Card>
                 );
               })}
             </div>
           </div>
         </section>
 
         <section className="py-24 px-4 relative overflow-hidden">
           <div className="max-w-4xl mx-auto text-center">
             <h2 className="text-4xl md:text-5xl font-bold mb-6 font-display">
               <span className="text-gradient">그룹</span>을 시작하세요
             </h2>
             <Button size="lg" className="group bg-primary hover:bg-primary/90 text-primary-foreground font-semibold px-10 py-7 text-lg" asChild>
               <a href="https://app.csw.live" target="_blank" rel="noopener noreferrer">
                 무료로 시작하기 <ArrowRight className="ml-2 h-5 w-5 group-hover:translate-x-1 transition-transform" />
               </a>
             </Button>
           </div>
         </section>
       </main>
       
       <Footer />
     </div>
   );
 }